import { createContext, type Dispatch, type ReactNode } from "react";
import { useImmerReducer } from "use-immer";
import {
  reducer,
  ScheduleDataState,
  type ScheduleDataStateAction,
} from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/ScheduleDataState.ts";
import useShowError from "@/shared/custom-hook/useShowError.ts";
import { useTranslation } from "react-i18next";

// eslint-disable-next-line react-refresh/only-export-components
export const ScheduleDataStateContext = createContext<
  ScheduleDataState | undefined
>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const ScheduleDataStateDispatchContext = createContext<
  Dispatch<ScheduleDataStateAction> | undefined
>(undefined);

export function ScheduleDataStateProvider(props: {
  children: ReactNode;
}): ReactNode {
  const { t } = useTranslation(["humanResources"]);
  const [dataState, dispatch] = useImmerReducer(
    reducer,
    new ScheduleDataState(),
  );
  useShowError(
    dataState.loadingError,
    t("timeManagement.errors.backend.schedules.read"),
  );

  return (
    <ScheduleDataStateContext.Provider value={dataState}>
      <ScheduleDataStateDispatchContext.Provider value={dispatch}>
        {props.children}
      </ScheduleDataStateDispatchContext.Provider>
    </ScheduleDataStateContext.Provider>
  );
}
